import type { Table as ReactTable, RowData } from "@tanstack/react-table";
import intl from "react-intl-universal";
import BadgeButtonTable from "../BadgeButtonTable";
import { RowBadgeButton } from "./styled";

export interface TableColumnTogglesProps<TData extends RowData> {
  readonly table: ReactTable<TData>;
}
const TableColumnToggles = <TData extends RowData,>({
  table,
}: TableColumnTogglesProps<TData>) => {
  const taggableColumns = table
    .getAllLeafColumns()
    .filter((column) => column.getCanHide());

  if (taggableColumns.length === 0) return null;

  return (
    <section aria-label={intl.get("commons.table.columnVisibilityToggles")}>
      <RowBadgeButton>
        {taggableColumns.map((column) => {
          const visible = column.getIsVisible();
          if (visible) return null;
          const label = String(column.columnDef.header ?? column.id);

          return (
            <BadgeButtonTable
              key={column.id}
              ariaPressed={visible}
              onClick={() => column.toggleVisibility()}
            >
              {label}
            </BadgeButtonTable>
          );
        })}
      </RowBadgeButton>
    </section>
  );
};

export default TableColumnToggles;
